export default __webpack_public_path__ + "static/media/placeholder_business01-en-mobile.19204335.png";